import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function ScrollDownIconSvg() {
  return (
    <svg
      width="44"
      height="16"
      viewBox="0 0 44 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 16L43.6506 0.25H0.349365L22 16Z" fill="#D9D9D9" />
    </svg>
  )
}

export default function ScrollDownIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={() => ScrollDownIconSvg()} {...props} />
}
